function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "27.644,67.644 10,50 50,10 67.644,27.644 62.93,32.356 50,19.427 19.427,50 32.356,62.93 "
});

var _ref3 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "32.356,72.356 50,90 90,50 72.356,32.356 67.644,37.07 80.573,50 50,80.573 37.07,67.644 "
});

var _ref4 =
/*#__PURE__*/
React.createElement("rect", {
  x: 35.049,
  y: 35.049,
  transform: "matrix(-0.7072 0.7071 -0.7071 -0.7072 120.7107 50.0049)",
  width: 29.902,
  height: 29.902
});

var SvgNotoresLogo = function SvgNotoresLogo(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "10 10 80 80",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    width: 80,
    height: 80,
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNotoresLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/notores-logo.a564aba0.svg";
export { ForwardRef as ReactComponent };